import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import {cart} from './cart';
import counter from './counter';
import products from './products';
import {postsBySubreddit} from './postsBySubreddit';
import {selectedSubreddit} from './selectedSubreddit';
import {todos} from './todos';
import {footer} from './footer';
import {navItems} from './navItems';
import {warnings} from './warnings';
import {visibilityFilter} from './visibilityFilter';

/**
 * All reducers are pure function under this folder.
 *
 * @format 所有Reducer函数均采用小驼峰法命名.
 */
export default combineReducers({ 
  'router': routerReducer, 
  cart,
  navItems,
  counter, 
  products,
  postsBySubreddit, 
  selectedSubreddit,
  todos, 
  visibilityFilter,
  'welcome': footer,
  'warnings': warnings,
  'footer': footer,
});



// WEBPACK FOOTER //
// ./usr/lib/ui/src/reducers/index.js